module.exports = __webpack_public_path__ + "static/media/First.9d650222.png";